import { render } from "./WebhooksComponent.vue?vue&type=template&id=7789d99a&scoped=true"
import script from "./WebhooksComponent.vue?vue&type=script&lang=js"
export * from "./WebhooksComponent.vue?vue&type=script&lang=js"

import "./WebhooksComponent.vue?vue&type=style&index=0&id=7789d99a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7789d99a"]])

export default __exports__